import ipConfig from "./ipConfig.json";
// import Header from "./components/Header";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// import theme from "./../src/theme";
import Products from "./components/Products";
import Register from "./components/Register";
import Login from "./components/Login";
import Checkout from "./components/Checkout";
import thanks from "./components/Thanks"
export const config = {
  endpoint: `https://qkart-frontend-nivw.onrender.com/api/v1`,
};

function App() {
  return (
    <div className="App">
    <Router> 
      
      <Switch>
        <Route exact path="/" component={Products} />
        <Route path="/register" component={Register} />
        <Route path="/login" component={Login} />
        <Route path="/checkout" component={Checkout}/>
        <Route path="/thanks" component={thanks}/>
       </Switch>
    
    </Router> 
    
  </div>
  );
}

export default App;
